export const DEFAULT_GANTT_TO_DELETE = { _id: '', name: '' };

export const COMPANY_GANTT_MODALS = {
  transferProjects: 'transferProjects',
  transferEmployees: 'transferEmployees',
  deleteModal: 'deleteModal',
};
